import React from 'react';
import LoaderComponent from '../../../../components/Loader';

function FormActionsBar({ isSubmitting, onSave, onCancel }) {
  return (
    <div className="formGroup workkard-creation-actions-row" data-test="workkard-form-actions">
      <div className="wth-2" />
      <div className="wth-4 rowFlex">
        <button
          type="button"
          data-test="workkard-form-save"
          className="btn-cc__primary"
          onClick={onSave}
          disabled={isSubmitting}
        >
          {isSubmitting ? <LoaderComponent /> : 'Save'}
        </button>
        {/* Need to hide temporarily */}
        {/* <button
          type="button"
          className="btn buttonGradient"
          onClick={onSave}
          disabled={isSubmitting}
        >
          Save and add activity
        </button> */}
        <button
          type="button"
          data-test="workkard-form-cancel"
          onClick={onCancel}
          disabled={isSubmitting}
          className="btn-cc__link"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default FormActionsBar;
